import { render, staticRenderFns } from "./ProjectFinances.vue?vue&type=template&id=1f580a10&scoped=true&"
import script from "./ProjectFinances.vue?vue&type=script&lang=js&"
export * from "./ProjectFinances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f580a10",
  null
  
)

export default component.exports